import { useState } from 'react'

import CostsCard from 'apps/employer_renewals/components/costs/CostsCard'
import Header from 'apps/employer_renewals/components/Header'
import PageContainer from 'apps/employer_renewals/components/layout/PageContainer'
import useQuoteSummary from 'apps/employer_renewals/hooks/useQuoteSummary'
import { useAllowances } from 'apps/employer_renewals/providers/AllowancesProvider'
import { useEmployerRenewalConfig } from 'apps/employer_renewals/providers/EmployerRenewalConfigProvider'
import { type Period } from 'apps/employer_renewals/types'

import FlatAllowancesContent from './flat/FlatAllowancesContent'
import RateChangeSummary from './rates/RateChangeSummary'
import SmartAllowancesContent from './smart/SmartAllowancesContent'

export default function ReviewAllowancesPage () {
  const { isUsingFlatAllowances } = useEmployerRenewalConfig()

  const [period, setPeriod] = useState<Period>('annual')

  const { renewalApproach, employerWillOfferQmeInRenewalYear } = useAllowances()
  const { currentYearCost, renewalYearCost, complianceCalculations, isLoading } = useQuoteSummary({
    renewalApproach,
    period,
  })

  return (
    <PageContainer maxWidth='md'>
      <Header heading='Estimated 2026 healthcare costs' textAlign='left' />
      <CostsCard
        renewalApproach={renewalApproach}
        currentYearCost={currentYearCost}
        renewalYearCost={renewalYearCost}
        period={period}
        qmeEnabled={employerWillOfferQmeInRenewalYear}
        onPeriodChange={setPeriod}
        isLoading={isLoading}
      >
        {isUsingFlatAllowances
          ? <FlatAllowancesContent
              complianceCalculations={complianceCalculations}
              isLoading={isLoading}
            />
          : <SmartAllowancesContent
              complianceCalculations={complianceCalculations}
              isLoading={isLoading}
            />}
      </CostsCard>
      <RateChangeSummary />
    </PageContainer>
  )
}
